import React, { Component } from "react";
import Load from "../assets/svg/other/loading2.svg";
import NextIcon from "../assets/svg/other/page/nextp.svg";
import Icon2 from "../assets/svg/other/page/prevp.svg";
import { get } from "../util/axiosLib";
import { logger } from "../util/logger";


export default class p2pMSellTrades extends Component {
  state = {
    sellTrades: [],
    currentPage: 1,
    pageNumber: 1,
    isLoaded: false,
  };

  loadTrades = async () => {
    try {
      const token = localStorage.getItem("tokenset");
      const headers = {
        authorization: `${token}`,
        "Content-Type": "application/json",
      };

      const getSellTradesReq = await get(
        `${process.env.REACT_APP_API_ENDPOINT}/p2p/listing/own?adsStatus=open&adsType=selling&limit=10`,
        headers
      );

      this.setState({ btcNgn: localStorage.getItem("btcNgnPrice") });

      const sellTrades = getSellTradesReq.data.data.trades;

      this.setState({
        sellTrades,
        totalCount: getSellTradesReq.data.data.totalCount,
        stPages: Math.round(getSellTradesReq.data.data.totalCount / 10),
        pageRange1: this.state.currentPage,
        pageRange2: parseInt(this.state.currentPage) + 1,
        pageRange3: parseInt(this.state.currentPage) + 2,
        isLoaded: true,
      });

      logger(this.state.totalCount);
    } catch (err) {
      logger(err);
      if (err.isAxiosError) {
        const errData = err.response;
        if (errData?.status === 403 || errData?.status === 401) {
          localStorage.setItem("expired", true)
        }
      }
    }
  };

  paginate = async (event) => {
    event.preventDefault();

    try {
      const token = localStorage.getItem("tokenset");
      const headers = {
        authorization: `${token}`,
        "Content-Type": "application/json",
      };

      await this.setState({
        pageNumber: event.target.value,
        currentPage: event.target.value,
        isLoaded: false,
      });
      const pageNumber = this.state.pageNumber;
      console.log(pageNumber);

      const getSellTradesReq = await get(
        `${process.env.REACT_APP_API_ENDPOINT}/p2p/listing/own?limit=10&page=${pageNumber}`,
        headers
      );

      const sellTrades = getSellTradesReq.data.data.trades;

      this.setState({
        sellTrades,
        //stPages: Math.round(getsellTradesReq.data.data.totalCount / 10),
        pageRange2: parseInt(this.state.currentPage) + 1,
        pageRange3: parseInt(this.state.currentPage) + 2,
        pageRange1: this.state.currentPage,
        isLoaded: true,
      });

      if (parseInt(this.state.currentPage) === parseInt(this.state.stPages)) {
        this.setState({
          pageRange2: 1,
          pageRange3: 2,
        });
      }
      if (
        parseInt(this.state.currentPage) ===
        parseInt(this.state.stPages) - 1
      ) {
        this.setState({
          pageRange2: parseInt(this.state.currentPage) - 2,
          pageRange3: parseInt(this.state.currentPage) - 1,
        });
      }

      logger(this.state.sellTrades);
    } catch (err) {
      logger(err.data);
      if (err.isAxiosError) {
        if (err.response.status === 401) {
          window.location = "/";
        }
      }
    }
  };

  nextPages = async (event) => {
    event.preventDefault();

    try {
      const token = localStorage.getItem("tokenset");
      const headers = {
        authorization: `${token}`,
        "Content-Type": "application/json",
      };

      this.setState({ isLoaded: false });

      const currentPage = this.state.currentPage;

      if (currentPage < this.state.stPages) {
        const nextPage = parseInt(currentPage) + 1;

        const getSellTradesReq = await get(
          `${process.env.REACT_APP_API_ENDPOINT}/p2p/listing/own?limit=10&page=${nextPage}`,
          headers
        );

        const sellTrades = getSellTradesReq.data.data.trades;

        this.setState({
          sellTrades,
          currentPage: nextPage,
          pageRange1: this.state.currentPage,
          pageRange2: parseInt(this.state.currentPage) + 2,
          pageRange3: parseInt(this.state.currentPage) + 3,
          isLoaded: true,
        });

        if (parseInt(this.state.currentPage) === parseInt(this.state.stPages)) {
          this.setState({
            pageRange2: 1,
            pageRange3: 2,
          });
        }
        if (
          parseInt(this.state.currentPage) ===
          parseInt(this.state.stPages) - 1
        ) {
          this.setState({
            pageRange2: parseInt(this.state.currentPage) - 2,
            pageRange3: parseInt(this.state.currentPage) - 1,
          });
        }
      }
    } catch (err) {
      logger(err);
      if (err.isAxiosError) {
        const errData = err.response;
        if (errData?.status === 403 || errData?.status === 401) {
          localStorage.setItem("expired", true)
        }
      }
    }
  };

  prevPages = async (event) => {
    event.preventDefault();

    try {
      const token = localStorage.getItem("tokenset");
      const headers = {
        authorization: `${token}`,
        "Content-Type": "application/json",
      };

      this.setState({ isLoaded: false });

      const currentPage = this.state.currentPage;

      if (currentPage >= 2) {
        const prevPage = parseInt(currentPage) - 1;
        console.log(prevPage);

        const getsellTradesReq = await get(
          `${process.env.REACT_APP_API_ENDPOINT}/p2p/listing/own?limit=10&page=${prevPage}`,
          headers
        );

        const sellTrades = getsellTradesReq.data.data.trades;

        this.setState({
          sellTrades,
          currentPage: prevPage,
          pageRange1: this.state.currentPage,
          pageRange2: parseInt(this.state.currentPage) - 2,
          pageRange3: parseInt(this.state.currentPage) - 1,
          //stPages: Math.round(getsellTradesReq.data.data.totalCount / 10),
          isLoaded: true,
        });

        if (currentPage === 1) {
          this.setState({
            pageRange2: 1,
            pageRange3: 2,
          });
        }
      }
    } catch (err) {
      logger(err);
      if (err.isAxiosError) {
        const errData = err.response;
        if (errData?.status === 403 || errData?.status === 401) {
          localStorage.setItem("expired", true)
        }
      }
    }
  };

  async componentDidMount() {
    await this.loadTrades();
  }

  render() {
    return (
      <div>
        {this.state.isLoaded ? (
          <div className="p2p-trades">
            {this.state.sellTrades.length >= 1 &&
              this.state.sellTrades.map((trade) => (
                <div className="p2p-trades-single" key={trade._id}>
                  <div className="pts-box">
                    <p className="pts-max">
                      {Number(this.state.btcNgn).toLocaleString()}{" "}
                      {trade.sourceUnit.toUpperCase() +
                        "/" +
                        trade.destinationUnit.toUpperCase()}{" "}
                      (Live Price)
                    </p>
                    <p className="pts-max">Rate: {420} NGN/USD</p>
                    <p className="pts-amount red bold uppercase">
                      {trade.currentVolume.$numberDecimal +
                        " " +
                        trade.destinationUnit}
                    </p>
                    <p className="pts-max uppercase">
                      Cost:{" "}
                      {Number(trade.totalCost.$numberDecimal).toLocaleString()}{" "}
                      {trade.sourceUnit}
                    </p>
                  </div>
                  <div className="pts-box">
                    <p className="pts-amount  bold ">Bitmama wallet</p>
                  </div>
                  <div className="pts-box ">
                    <p className="pts-amount  bold ">
                      {trade.userData?.username || "User"}
                    </p>
                  </div>
                  <div className="pts-box">
                    <button
                      onClick={(e) =>
                        (window.location = "/dashboard/p2pview/" + trade._id)
                      }
                      className="pts-sell"
                    >
                      View listing
                    </button>
                  </div>
                </div>
              ))}
              {this.state.sellTrades.length < 1 && (
                 <div className="p2p-trades-single">
                    <div className="pts-box">
                    <p className="bold"> No listings yet </p>
                    </div>
                 </div>
              )}
            <div className="paginate-box">
              {this.state.totalCount > 10 && (
                <>
                  <p className="pts-max">
                    {" "}
                    Page {this.state.currentPage} of {this.state.stPages}
                  </p>
                  <div className="paginate-actions">
                    {this.state.currentPage >= 2 && (
                      // <button onClick={this.prevPages}>Prev</button>
                      <img
                        className="paginate-arrows flip"
                        src={NextIcon}
                        onClick={this.prevPages}
                        alt="prev"
                      />
                    )}
                    {this.state.currentPage <= 1 && (
                      // <button onClick={this.prevPages}>Prev</button>
                      <img className="paginate-dis" src={Icon2} alt="prev" />
                    )}

                    {this.state.currentPage < this.state.stPages && (
                      <img
                        className="paginate-arrows"
                        src={NextIcon}
                        onClick={this.nextPages}
                        alt="next"
                      />
                    )}
                    {parseInt(this.state.currentPage) ===
                      parseInt(this.state.stPages) && (
                      <img
                        className="paginate-dis flip"
                        src={Icon2}
                        alt="next"
                      />
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        ) : (
          <div className="loading-a" id="load">
            <img src={Load} alt="loading" />
          </div>
        )}
      </div>
    );
  }
}
